import { useState, useEffect } from "react";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {  faExclamationCircle, faPortrait } from "@fortawesome/free-solid-svg-icons";
import { CustomTooltip, isCanariasCeutaOrMelillaOrBaleares } from "../../helpers/functionalities";

export default function ProveedorCard({
    proveedor, 
}) {
    const [hasWarning, setHasWarning] = useState(false);

    useEffect(() => {
        const {codigo_postal, poblacion, pais_facturacion_id} = proveedor;

        if(pais_facturacion_id) {
            if(pais_facturacion_id === 1 && (codigo_postal && poblacion)) {
                if(isCanariasCeutaOrMelillaOrBaleares(parseInt(proveedor.codigo_postal))) setHasWarning(true); 
            } else { setHasWarning(true); }
        }
      
    }, [proveedor]);
    
    return (
        <div className="w-100 d-flex flex-wrap align-items-stretch justify-content-between custom-card">
           <div className="w-100 d-flex flex-wrap flex-lg-nowrap align-items-stretch justify-content-between">
                <div className="d-flex align-items-start">
                    <div className="d-flex flex-column me-3">
                        <span className="icon">
                            <FontAwesomeIcon icon={faPortrait} size="1x" color="#215732" />
                        </span>
                    </div>

                    <div className="d-flex flex-column">
                        <div className="d-flex align-items-center mb-1">
                            <h3 className="text-success">{proveedor?.nombre}</h3>

                            { (hasWarning) ?
                                <CustomTooltip
                                    title={
                                        <React.Fragment>
                                            <small className="m-0">Atención! Proveedor de Baleares, Canarias, Ceuta, Melilla o fuera de España.</small>
                                        </React.Fragment>
                                    }
                                >
                                    <span className="align-self-start me-2" style={{cursor: 'pointer'}}>
                                        <FontAwesomeIcon icon={faExclamationCircle} size="lg" className="action" color="#ffc107" /> 
                                    </span>
                                </CustomTooltip>
                                : ''
                            }
                        </div>
                    

                        <p className="m-0 text-uppercase">CIF: {proveedor?.cif ? proveedor?.cif : '-'}</p>
                        <p>Teléfono: {proveedor.telefono}</p>
                        <p>Email: {proveedor.email}</p>

                        <div className="d-flex flex-wrap">
                            { (proveedor?.credito) ?
                                <small className="fw-bold text-uppercase">A crédito</small>
                                : ''
                            }
                            { (proveedor?.credito && proveedor?.integracion) ? <p className="mx-2">|</p> : ''}
                            { (proveedor?.integracion) ?
                                <small className="fw-bold text-uppercase">Integrado</small>
                                : ''
                            }
                        </div>
                    </div>
                </div>

                <div className="d-flex flex-column">
                    <div className="w-100 d-flex align-items-center flex-wrap">
                        <label>SCORE: &nbsp;</label>
                        <p className={"fw-bold " + (proveedor.score >= 7 ? 'text-green' : proveedor.score >= 6.5 ? 'text-warning' : 'text-danger')}>
                            {proveedor.score ? proveedor.score : '-'}
                        </p>
                    </div>  
                        
                    { (proveedor.descuento === 'fijo' || proveedor.descuento === 'variable') &&
                        <div>
                            <div className="w-100 d-flex align-items-center flex-wrap">
                                <label>Descuento: &nbsp;</label>
                                <p>{proveedor.descuento ? <b className="text-success text-uppercase">{proveedor.descuento}</b> : ''}</p>
                            </div>

                            <div>
                                { proveedor.descuentos.map(descuento => {
                                    return (
                                        <div>
                                            <p className="cliente-card-small">
                                                {descuento.min} - {descuento.max ? descuento.max : 'sin máximo'} = {descuento.descuento} %
                                            </p>
                                            <div className="w-100 d-flex align-items-center">
                                                { descuento.tipo_piezas.length > 0 &&
                                                    descuento.tipo_piezas.map((tp, i) => {
                                                        return (
                                                        <span className="cliente-card-small"> 
                                                                {tp.nombre} 
                                                                {(i >= 0 && i < descuento.tipo_piezas.length -1) ? 
                                                                <span className="mx-2">|</span>
                                                                : ''
                                                                }
                                                            </span>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                    )
                                }) }
                            </div>
                        </div>
                    }
                </div>
                
                <div className="d-flex flex-column">
                    <label>Dirección:</label>
                    <p>{proveedor?.direccion}</p>
                    <p>{(proveedor.codigo_postal + ' ' + proveedor.poblacion + ", " + proveedor.area)}, {proveedor.pais_id ? proveedor.pais.nombre : ''}</p>
                </div>

                <div className="d-flex flex-column">
                    <label>Administracion</label>
                    <p>Nombre: {proveedor.persona_administracion ? proveedor.persona_administracion : '-'}</p>
                    <p>Teléfono: {proveedor.telefono_administracion ? proveedor.telefono_administracion : '-'}</p>
                    <p>Email: {proveedor.email_administracion ? proveedor.email_administracion : '-'}</p>
                    <p>Tipo Pago: {proveedor?.sepa ? 'SEPA' : 'Transferencia/Domiciliado'}</p>
                    {proveedor.iban ? <p>IBAN: {proveedor.iban}</p> : null}
                </div>

                <div className="d-flex flex-column">
                    <label>Recambios</label>
                    <p>Nombre: {proveedor.persona_recambios ? proveedor.persona_recambios : '-'}</p>
                    <p>Teléfono: {proveedor.telefono_recambios ? proveedor.telefono_recambios : ''}</p>
                    <p>Email: {proveedor.email_recambios ? proveedor.email_recambios : '-'}</p>
                    
                </div>

                <div className="d-flex flex-column">
                    <label>Incidencias</label>
                    <p>Nombre: {proveedor.persona_incidencias ? proveedor.persona_incidencias : '-'}</p>
                    <p>Teléfono: {proveedor.telefono_incidencias ? proveedor.telefono_incidencias : '-'}</p>
                    <p>Email: {proveedor.email_incidencias ? proveedor.email_incidencias : '-'}</p>
                </div>
            </div>
        </div>
    )
}